<template>
  <div class="trainScene-wrap">
    <mu-dialog :open="true"  dialogClass="trainScene" bodyClass="trainScene-body">
      <div class="train-filter">
        <!-- 训练过滤 -->
        <span v-for="(item,index) in filter_items" :key="index" :class="{'selected-filter':selected_filter == index}" @click="filter_train(index)">{{item.name}}</span>
      </div>
      <div class="train-classification">
        <trainMenu  ref="trainmenu" :trainCategories='trainCategories' @category-path-updated = 'onTrainCategoryChoose' :isModal="isModal"></trainMenu>
      </div>
      <div class="trainScene-content">
        <div v-if="showLoading" class="time-train-loading" style="padding-right:40px; text-align: center; display: flex; align-items: center;justify-content: center;  flex-grow: 1;">
          <mu-circular-progress :stroke-width="5" class="demo-circular-progress" :size="48"></mu-circular-progress>
        </div>
        <div style="padding-right:40px; text-align: center; display: flex; align-items: center;justify-content: center;  flex-grow: 1;" v-if="showAddPlanRoute">当前没有训练方案，<span class="" @click="toTrainPlan(caseId)"><a style="text-decoration:underline;cursor:pointer;">添加方案</a></span>
        </div>
        <div v-if="noTrain" class="no-train">更多训练敬请期待</div>
        <card-list :isModal="isModal" :listItems = 'currentTrainCategory ? sortGame(currentTrainCategory.games) : []' :itemComponent = 'trainCard' @list-item-clicked = 'onTrainClicked'/>
      </div>
      <div class="trainScene-actions">
        <mu-dialog dialogClass="diaClass" bodyClass="trainScene-bodyClass" titleClass="trainScene-title" :open="dialog" title="训练设置" >
          <selectLevel :patientId="caseId" :defaultTime="defaultTime" :showHardBar="showHardBar"></selectLevel>
          <mu-raised-button slot="actions" style="position:absolute;left:100px;width:120px;height:40px;" class="conf-cancel-btn" @click="close" primary label="取消"/>
          <mu-raised-button slot="actions" style="position:absolute;right:100px;width:120px;height:40px;" :disabled="!startTrain" primary @click="toTrain" label="开始训练"/>
        </mu-dialog>
        <digTrainContentmodal :game="game" @close="showModal=false" v-if="showModal"></digTrainContentmodal>
        <div class="trainScene-button-wrap">
          <mu-raised-button  label='取消' @click="cancelhandler"  style="width:120px;border-radius:40px;margin-right:70px;margin-left:20px;background-color:#999999;"  primary/>
          <mu-raised-button  label='去训练' :disabled="showDoTrain" style="width:120px;border-radius:40px;" @click="submitAction" primary/>
        </div>
      </div>
    </mu-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import {getAllGames} from '../../../assets/js/common.js'
import selectLevel from '../../common/selectLevel'
import digTrainContentmodal from './digTrainContentmodal.vue'
import {mapState,mapMutations} from 'vuex'
import trainMenu from '../../common/trainMenu.vue'
import TrainListItem   from '../../bz/train-card';
import CardList from '../../../foundation/ui/controls/card-list';
import {removeByValue} from '../../../assets/js/common.js';
import bz_utils from '../../common/tree/utils'

export default {
  // 获取父级数据
  props: {
    //已经选择的训练方案
    games: {
      type: Array,
      default: function(){
        return []
      }
    },
    caseId:{
      type: String,
      default: function(){
        return this.$route.params.id
      }
    },
  },
  data(){
    return{
      showLoading:false,
      isModal:true,
      trainCategories: bz_utils.buildTrainCategoryTree(),
      trains:null,
      gamesInDailyTrains : {},
      gamesInPlan : {},
      selectedGames : {},
      selected_filter:2, //默认选择今日训练
      currentTrainCategory:null,
      trainPlanList:[],
      trainDailyList:[],
      trainCard: TrainListItem,
      isModal:"true",
      count:0,
      showDoTrain:true,
      checkItem:{},
      noContent:false,
      oneGrade:"",
      trainList:[],
      Games:{},//全部游戏以树状结构展示
      config: GLOBAL,
      filter_items:[{name:"全部"},{name:"训练方案"},{name:"今日训练"}],
      filter_oneGrade:[{name:"全部",num:0},{name:"认知",num:10},{name:"言语-语言",num:11},{name:"情绪与社会认知",num:12}],
      oneNum:0, //游戏分类高亮控制器
      oneGrade:0, //一级脑能力高亮控制器
      Games_oneGrade:[],//全部游戏的一级脑能力
      showGames:[],//展示在列表中的游戏
      address: GLOBAL.cognition,
      selected_item: -1,
      dialog:false,
      hasTrain:false,
      showModal:false,
      game:"",
      /* 游戏设置默认值 */
      defaultTime:2,
      showHardBar:true,
      noTrain:false,
    }
  },
  components:{
    selectLevel,
    digTrainContentmodal,
    trainMenu,
    'card-list': CardList,
  },
  computed:{
    showAddPlanRoute(){
      if(this.selected_filter > 0
        && Object.values(this.trainDailyList).length === 0){
          this.noContent = true;
          this.noTrain = false;
          return this.noContent;
      }else{
        this.noContent = false;
        return this.noContent;
      }
    },
    ...mapState(["startTrain"])
  },
  methods:{
    toTrainPlan (id) {
      this.$router.push({name: 'trainPlan', params: {id: id}});
      this.$emit('close');
    },
    onTrainClicked(ev){
      this.trains.forEach(x=>{
        x["selected"] = false;
      });
      this.checkItem = ev.itemData;
      if (this.checkItem.selected){
        this.checkItem.selected = false;
      }else{
        this.checkItem.selected = true;
      }
      this.showDoTrain = false;
    },
    sortGame: function(games){
      var arr = [];
      var obj = {}; //去重
      if(this.count > 0){
        this.trains.forEach((item)=>{
          games.forEach((game)=>{
            if(game.id == item.id){
              arr.push(game);
            }
          })
        })
      }
      arr = arr.reduce((cur,next) => {
        obj[next.name] ? "" : obj[next.name] = true && cur.push(next);
        return cur;
      },[]);
      return arr;
    },
    onTrainCategoryChoose(categoryPath){
      this.noTrain = false;
      if(categoryPath.length > 1 && categoryPath.slice(-1)[0].games.length == 0 && !this.noContent){
        this.noTrain = true;
      }
      if(this.trains === null){
        this.getDaily().then(()=>{
        this.getPlan().then(()=>{
          var self = this;
          let cat = categoryPath.slice(-1)[0];
          this.currentTrainCategory = cat;
          if (this.trains === null){
            Vue.http({
              method: 'GET',
              url: '/api/Game/getAllGames',
            }).then(resp=>{
              let selection = this.selectedGames;
              let gamesInDailyTrains = this.gamesInDailyTrains;
              this.trainDailyList.forEach((x)=>{
                if(x.id){
                  gamesInDailyTrains[x.id] = x;
                }else{
                  gamesInDailyTrains[x.taskId] = x
                }
            })
            let gamesInPlan = this.gamesInPlan;
            this.trainPlanList.forEach((x)=>{
              if(x.id){
                gamesInPlan[x.id] = x;
              }else{
                gamesInPlan[x.taskId] = x
              }
            })
            let flat_games = bz_utils.canonicalizeGames(resp.data.data);
            flat_games.forEach(x=>{
              x["selected"] = false;
            });
            this.trains = flat_games;
            this.count ++;
            this.trainCategories.resetGames(this.trains.filter(x=>x.id in this.gamesInDailyTrains));
            this.showLoading = false;
            })
          }
        })
      })
      }else{
        let cat = categoryPath.slice(-1)[0];
        this.currentTrainCategory = cat;
      }
    },
    show: function(){
      this.resetData();
      this.showDialog = true;
    },
    resetData: function(){
      this.trains = null;
      this.gamesInDailyTrains = {};
      this.gamesInPlan = {};
      this.selectedGames = {};
    },
    close () {
      this.dialog = false;
    },
    filter_train(index){
      this.noTrain = false;
      this.selected_filter = index;
      if(this.selected_filter == 2){
        this.trainCategories.resetGames(this.trains.filter(x=>x.id in this.gamesInDailyTrains));
      }else if(this.selected_filter == 1){
        this.trainCategories.resetGames(this.trains.filter(x=>x.id in this.gamesInPlan));
      }else{
        this.trainCategories.resetGames(this.trains);
      }
      this.$forceUpdate();
    },

    // 获取训练方案的游戏列表
    getPlan:function(id){
      return Vue.http({
        method: 'GET',
        url:'api/Train/getManualProgram',
        params: {
          'id': this.caseId
        }
      })
      .then((res)=>{
        var listAll = res.data.data.cogn.concat(res.data.data.lan);
        if (listAll.length > 0) {
          this.trainPlanList = res.data.data.cogn.concat(res.data.data.lan);
        }else{
          console.log("暂无训练")
        }
      })
    },
    // 获取今日训练的游戏列表
    getDaily:function(id){
      this.showLoading = true;
      return Vue.http({
        method: 'GET',
        url:'/api/Train/getDailyTrainingProgram',
        params: {
          'id': this.caseId
        }
      })
      .then((res)=>{
        var listAll = res.data.data.cogn.concat(res.data.data.lan);
        if (listAll.length > 0) { //当今日训练有内容时
          this.trainDailyList = res.data.data.cogn.concat(res.data.data.lan);
        }else{
          this.showLoading = false;
          console.log("暂无训练");
        }
      })
    },

    
    init_AlloneGrade(num,item){
      //初始化全部训练的一级脑能力标签
      this.Games_oneGrade = []; //初始化一级脑能力
      if(num !== 0){
        for(var oneGrade in this.Games.children[item].oneGrade){
          this.Games_oneGrade.push(this.Games.children[item].oneGrade[oneGrade]);
        }
        this.showGames = this.Games.children[item].oneGrade.all.games;
      }else{
        for(var oneGrade in this.Games.oneGrade){
          this.Games_oneGrade.push(this.Games.oneGrade[oneGrade]);
        }
        this.showGames = this.Games.oneGrade.all.games;
      }
      this.filter_repeat_item(this.showGames);
    },
    unique(arr) {
        const res = new Map();
        return arr.filter((a) => !res.has(a) && res.set(a, 1))
    },
    filter_repeat_item(showGames){//去除重复的游戏
      let arr = this.unique(showGames);
      this.showGames = arr;
    },
    select_oneGrade(item,index){
      this.switch_train();
      var obj = {};
      this.oneGrade = index;
      this.showGames = item.games;
      this.showGames =  this.showGames.reduce((cur,next) => {
        obj[next.id] ? "" : obj[next.id] = true && cur.push(next);
        return cur;
      },[]);
    },
    select_train(item,index){
      this.selected_item = index;
      this.checkItem = item;
      this.showDoTrain = false;
    },
    switch_train(){
      //切换标签，无论是游戏过滤，类型的筛选还是一级脑能力的筛选，都要执行这个逻辑
      //去掉游戏选中的效果，去训练的按钮置灰
      this.selected_item = -1;
      this.checkItem = {};
      this.showDoTrain = true;
    },
    cancelhandler(){
      this.$emit('close');
    },
    toTrain(){
      //通过设置难度等级和游戏时间开始训练
      this.$parent.showModal = false;
      this.$emit('submitData',this.checkItem);
    },
    submitAction(){
      console.log(this.checkItem);
      if(this.checkItem.lesson_type=='b'){
        this.dialog = true;
        this.$store.commit("getData",this.checkItem);//将选中游戏的信息传给vuex，selectLevel需要
        this.defaultTime = 2;
        this.showHardBar = true;
      }else if(this.checkItem.lesson_type=='l'){
        this.defaultTime = 5;
        this.showHardBar = false;
        this.dialog = true;
        this.$store.commit("getData",this.checkItem);//将选中游戏的信息传给vuex，selectLevel需要
      }else{
        this.$parent.showModal = false;
        this.$emit('submitData',this.checkItem);
      }
    },
  }
}
</script>
<style>
  .mu-dialog.trainScene {
    display: flex;
    flex-direction: column;
  }
  .mu-dialog-body.trainScene-body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  @media (min-width:1280px), (-webkit-min-width:1280px){
    .mu-dialog.trainScene{
      position: relative;
      width: 1024px;
      max-width: 1024px;
      height:640px;
      max-height:640px;
    }
  }
  @media (-webkit-max-width:1280px),(max-width:1280px){
    .mu-dialog.trainScene{
      position: relative;
      width: 1024px;
      max-width: 1024px;
      height:550px;
      max-height:550px;
      overflow: hidden;
    }
  }
  .train-filter,.train-classification{
    height: 60px;
    width:100%;
    border-bottom: 1px solid #eee;
  }
  .train-classification{
    height:152px !important;
    border-bottom:0px !important;
  }
  
  .train-filter span,.nowtrain{
    line-height: 60px;
    margin-left: 40px;
    cursor: pointer;
    color: #999;
    font-size: 14px;
  }
  .train-filter .selected-filter,.on{
    color:#333333;
    font-weight: 600;
  }
  .trainScene-body{
    width:100%;
    padding: 0 !important;
  }
  .oneGrade-classification{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items:center;
    min-height: 60px;
    padding: 0 10px 0 40px;
  }
  .oneGrade{
    margin-right: 40px;
    font-size: 14px;
    cursor: pointer;
    line-height: 30px;
  }
  .trainScene-content{
    width:100%;
    flex-grow: 1;
    padding: 0px 0px 0px 40px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    overflow: auto;
  }
  .trainScene-actions{
    bottom: 0;
    width: 100%;
    height: 50px !important;
    background-color: #fff;
  }
  .trainScene-button-wrap{
    width: 380px;
    height: 50px !important;
    line-height: 50px !important;
    margin: 0 auto;
  }
  .train-items{
    position: relative;
    box-sizing: content-box;
    width:140px;
    height: 140px;
    margin-top: 34px;
    margin-right: 52px;
    padding-bottom: 26px;
    cursor: pointer;
  }
  .trainScene-wrap .itemName{
    position: absolute;
    bottom: 0;
    font-size: 14px;
    color:#333333;
  }
  .trainScene-content .mengban{
    position: absolute;
    top: 0 !important;
    left:0 !important;
    background-color: #000;
    opacity: 0.5;
    width: 140px;
    height: 140px;
  }
  .trainScene-content .mengban img{
    position: absolute;
    left: 50%;
    top:50%;
    transform: translate(-50%,-50%);
  }
  .diaClass{
    width: 500px !important;
    max-width: 500px !important;
    height: 350px !important;
    max-height: 350px !important;
  }
  .trainScene-bodyClass{
    margin-top: 50px;
  }
  .trainScene-title{
    justify-content: center!important;
    color: #333333;
    font-size: 16px;
    font-weight: bold;
  }
  .time-train-loading{
    position: absolute;
    background-color: #fff;
    height: 380px;
    width: 944px;
  }
  .no-train{
    position: absolute;
    width: 944px;
    height: 380px;
    text-align: center;
    line-height: 380px;
  }
</style>



// WEBPACK FOOTER //
// trainModal2.vue?318667b2